import AudioRecorder from 'audio-recorder-polyfill';
import mpegEncoder from './mpegEncoder';
// if (typeof window !== 'undefined') {
// const AudioRecorder = require('audio-recorder-polyfill');

AudioRecorder.encoder = mpegEncoder;
AudioRecorder.prototype.mimeType = 'audio/mpeg';
if (!!window) {
	window.MediaRecorder = AudioRecorder;
}
// }
